module.exports = __webpack_public_path__ + "static/img/ic_new_open.980f4e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_new_open.png
// module id = yn1j
// module chunks = 1